export const nft_CONNECT_MODAL_ID = "nft_CONNECT_MODAL_ID";
export const INJECTED_PROVIDER_ID = "injected";
export const CACHED_PROVIDER_KEY = "nft_CONNECT_CACHED_PROVIDER";
